import { message } from "antd";
import axios from "axios";

const botApiUrl = axios.create();

const server = window.localStorage.getItem("server");

botApiUrl.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        window.localStorage.removeItem("accessToken");
        window.localStorage.removeItem("idUser");
        window.location.reload();
      } else if (error.response.status === 500) {
        message.error("Erro 500: Problema interno no servidor.");
      }
    } else {
      message.error("Erro sem resposta do servidor:", error.message);
    }
    return Promise.reject(error);
  }
);

const URL_API =
  server?.toLowerCase().includes("nodeevo")
    ? "https://manager1.techsbot.com.br"
    : process.env.REACT_APP_BOT_API_URL;


botApiUrl.defaults.baseURL = URL_API;


export default botApiUrl;
